var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{staticClass:"social-rewards-page",attrs:{"title":((_vm.isFirstAccess && !_vm.isMobileDevice) || !_vm.isFirstAccess) && 'Social Rewards',"config":{
    showTitleQuestion: !_vm.isFirstAccess,
    needsWidget: true,
    isEmptyState: _vm.isFirstAccess,
    loading: _vm.loading,
    needsActivedRewards: true,
    needsActivedBilling: _vm.isBillingModuleV4
  }},on:{"title-question-click":_vm.openModal}},[(!_vm.loading)?_c('div',{staticClass:"social-rewards-page__content"},[(_vm.isFirstAccess)?_c('SocialRewardsEmptyState',{on:{"click":_vm.onClickGetStarted}}):_c('div',[_c('CampaignList',{attrs:{"socialRewardsCampaigns":_vm.socialRewardsCampaigns},on:{"status-changed":_vm.statusChanged}})],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }